import { render, staticRenderFns } from "./ConfirmReturns.vue?vue&type=template&id=8d704c70&scoped=true"
import script from "./ConfirmReturns.vue?vue&type=script&lang=js"
export * from "./ConfirmReturns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d704c70",
  null
  
)

export default component.exports